import React from 'react';

class SMSearchPagerView extends React.Component {
  
  constructor(props) {
    super(props);
  }
  
  pageDidSelect(e) {
    const page = $(e.currentTarget).data("page");
    if(this.props.delegate && typeof this.props.delegate.pageDidSelect === 'function') {
      this.props.delegate.pageDidSelect(page, e);
    }
  }
  
  naviDidSelect(e) {
    const page = this.getParameterByName(e.currentTarget.href, "page");
    if(this.props.delegate && typeof this.props.delegate.pageDidSelect === 'function') {
      this.props.delegate.pageDidSelect(page, e);
    }
  }
  
  getParameterByName(url, name) {
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(url || "");
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
  
  render() {
    const links = this.props.links;
    let rows = [];
    if (links["prev"]) {
      rows.push(
        <a key="prev" onClick={this.naviDidSelect.bind(this)} className="page-nav__numbers is-prev" href={links["prev"]}><i className="fa fa-angle-left"></i></a>
      );
    }
    let summary = null;
    if (links["first"] && links["last"]) {
      const firstPage = parseInt(this.getParameterByName(links["first"], "page"));
      const lastPage = parseInt(this.getParameterByName(links["last"], "page"));
      
      let currentFirst = this.props.currentPage - 4;
      if (currentFirst < firstPage) {
        currentFirst = firstPage;
      }
      let currentLast = currentFirst + 9;
      if (currentLast > lastPage) {
        currentLast = lastPage;
      }
      
      for (var i = currentFirst; i <= currentLast; i++) {
        if (i == this.props.currentPage) {
          rows.push(
            <span key="current" className="page-nav__numbers is-current">{i}</span>
          );
        } else {
          let pageUrl = links["first"].replace(/page=\d/, "page=" + i);
          rows.push(
            <a onClick={this.pageDidSelect.bind(this)} key={i} data-page={i} className="page-nav__numbers" href={pageUrl}>{i}</a>
          );
        }
      }
      
      if (this.props.totalCount > 0) {
        const perPage = this.props.perPage;
        const start = (this.props.currentPage - 1) * this.props.perPage + 1;
        let end = this.props.currentPage * this.props.perPage;
        if (this.props.totalCount < end) end = this.props.totalCount;
        summary = <p>検索結果 <strong>{this.props.totalCount}件中</strong> {start}～{end}件を表示</p>;
      } else {
        summary = <p>検索結果 <strong>{this.props.totalCount}件</strong></p>;
      }
    }
    if (links["next"]) {
      rows.push(
        <a key="next" onClick={this.naviDidSelect.bind(this)} className="page-nav__numbers is-next" href={links["next"]}><i className="fa fa-angle-right"></i></a>
      );
    }
    
    let className = "search-list__main-nav";
    if (this.props.options && this.props.options.className) {
      className = "search-list__main-nav";
    }
    
    return(
      <div className={className}>
        {summary}
        <div className="page-nav">
          {rows}
        </div>
      </div>
    );
  }
  
}
export default SMSearchPagerView;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchPagerView.jsx